import { Box, Grid } from '@material-ui/core'
import { Button } from 'components/facets'
import { useInventoryStore } from 'lib/hooks/useInventoryStore'
import { useTranslation } from 'react-i18next'
import { AggregatedInventoryArticle, InventoryArticle, INVENTORY_STEPS } from 'shared'
import { DiffViewer } from './DiffViewer'

interface ConflictsSolverProps {
  incomingStock: InventoryArticle[]
  onConfirm: (selectedData: AggregatedInventoryArticle[]) => void
}

export const ConflictsSolver = ({ onConfirm }: ConflictsSolverProps): JSX.Element => {
  const { t } = useTranslation()
  const numConflicts = useInventoryStore((state) => state.numConflicts)
  const numSolvedConflicts = useInventoryStore((state) => state.numSolvedConflicts)
  // const setNumSolvedConflicts = useInventoryStore((state) => state.setNumSolvedConflicts)
  const diffSelectedArticles = useInventoryStore((state) => state.diffSelectedArticles)
  const setStep = useInventoryStore((state) => state.setStep)

  const handleConfirmSolution = () => {
    onConfirm(diffSelectedArticles)
  }

  const handleGoBack = () => {
    setStep(INVENTORY_STEPS.SOURCE_SELECTION.idx)
  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
          <Box>
            <Box className="title" marginBottom={5}>
              <div className="titleFont">{t('ptInventory.solveConflicts.title')}</div>
            </Box>

            <Box marginY={2}>
              <div className="bodyFont">{t('ptInventory.solveConflicts.text1')}</div>
            </Box>

            <Box marginY={2}>
              <div className="bodyFont">{t('ptInventory.solveConflicts.text2')}</div>
            </Box>

            <Box marginTop={10} className="inventoryButtonContainer">
              <Box width="260px" marginTop={2}>
                <Button
                  fullWidth
                  data-testid="confirm-btn"
                  variant="contained"
                  disabled={numSolvedConflicts !== numConflicts}
                  onClick={handleConfirmSolution}
                >
                  {t('ptInventory.solveConflicts.confirmSolution')}{' '}
                  {`(${numSolvedConflicts}/${numConflicts})`}
                </Button>
              </Box>
              <Box marginTop={2}>
                <div>
                  {t('ptInventory.solveConflicts.explainConfirmSolution', {
                    numConflicts,
                    conflicts: numConflicts === 1 ? 'conflict' : 'conflicts',
                  })}
                </div>
              </Box>
              <Box width="260px" marginTop={4}>
                <Button
                  fullWidth
                  data-testid="go-back-btn"
                  variant="outlined"
                  onClick={handleGoBack}
                >
                  {t('ptInventory.solveConflicts.goBack')}
                </Button>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
          <Box className="scrollable">
            <DiffViewer />
          </Box>
        </Grid>
      </Grid>
    </>
  )
}
